import * as Yup from 'yup';

const schema = Yup.object().shape({
    "nome": Yup.string().required("Informe o nome")
});

export default schema;